import React from "react";
import pptxgen from "pptxgenjs";
import "./App.css";

let theme = ""

let logo = "images/logo-etat.svg"
let logodark = "images/logo-etat-dark.svg"
//let font            = "marianne"
let background = "images/marianne.jpg"
let backgroundcolor = "#000091" //#2a2a2b
let maintitle = 'Un outil d’audit pour l’accessibilité - Open Sourcé par l’État'

// Simplifier la bureaucratie
// Libérer une méthode
// La bureaucratie numérisée
// RSE

let content = [
  {
    "name": "Simplifier la bureaucratie\xa0?",
    "slides": [
      {
        "name": "Un monde numérisé\xa0?",
        "picto": "images/ico-courriel.svg",
        "content": "Informations échangées par mail"
      },
      {
        "name": "Audit RGAA",
        "illustration": "images/audit-page.png"
      },
      {
        "name": "Résultat d’audit RGAA",
        "illustration": "images/audit-synthese.png"
      },
      {
        "name": "Synthèse d’audit RGAA",
        "illustration": "images/audit-resultats.png"
      },
      {
        "name": "100% conforme",
        "content": "au RGAA 4.1, dès aujourd’hui (risque juridique).",
        "note": "Le premier chapitre du décret de 2019 qui impose aux sites internet appartenant à certaines catégories d'être accessibles, et ce sans délai, en conformité avec les normes européennes ou internationales. Cette partie répond aux deux premiers paragraphes de l'article 47 et peut donner lieu à sanction juridique"
      }
    ]
  },
  {
    "name": "Libérer une méthode",
    "slides": [
      {
        "name": "Format ouvert",
        "content": "Utilisation du format csv identique aux documents d’audits existant."
      },
      {
        "name": "Open Source",
        "content": "Hébergement à la DINUM, URL fixe pour appeler un outil, avoir une confiance institutionnelle…"
      },
      {
        "name": "Exemplarité",
        "content": "Simplifier la démarche pour maximiser le temps pour les corrections."
      },
      {
        "name": "Uniformiser",
        "content": "Proposer d’appliquer une méthode au plus grand monde."
      }
    ]
  },
  {
    "name": "La bureaucratie numérisée",
    "slides": [
      {
        "name": "Périmètre",
        "illustration": "images/animation-depart.svg"
      },
      {
        "name": "Thème goHugo",
        "picto": "images/frago.png",
        "content": "https://github.com/DISIC/frago/",
        "note": "Anticiper les demandes légales dans les appels d’offres."
      },
      {
        "name": "Dépôt Git",
        "content": "Pas de base de données : archivage, écriture collaborative…"
      },
      {
        "name": "GSS",
        "content": "Gestionnaire de Site Statique"
      },
      {
        "legend": "Stockage",
        "screenshot": "images/illustration-arbo.png"
      },
      {
        "name": "Archivage",
        "illustration": "images/animation-archivage.svg",
        "illustrationpptx": "images/animation-collecte.svg"
      },
      {
        "name": "Interface web",
        "content": "Partage d’information en ligne. Document unique de discussion avec une adresse fixe."
      },
      {
        "legend": "Liste des démarches",
        "screenshot": "images/illustration-accueil.png"
      },
      {
        "name": "Collecte",
        "illustration": "images/animation-collecte.svg",
        "illustrationpptx": "images/animation-publication.svg"
      },
      {
        "name": "Génération automatisée",
        "content": "Déclaration d’accessibilité, schéma pluriannuel, statistiques dans le temps…"
      },
      {
        "legend": "Détail d’une démarche",
        "screenshot": "images/illustration-projet.png"
      },
      {
        "legend": "Synthèse d’audit",
        "screenshot": "images/illustration-accessibilite-synthese.png"
      },
      {
        "legend": "Résultat d’audit",
        "screenshot": "images/illustration-accessibilite-criteres.png"
      },
      {
        "legend": "Déclaration d’accessibilité",
        "screenshot": "images/illustration-declaration.png"
      },
      {
        "name": "Publication",
        "illustration": "images/animation-publication.svg",
        "illustrationpptx": "images/animation-collecte2.svg"
      },
      {
        "name": "Open Data",
        "content": "Simplifier la collecte grâce une API, générer des rapports, construire des observatoires…"
      },
      {
        "legend": "API",
        "screenshot": "images/illustration-api.png"
      },
      {
        "name": "Collecte API",
        "illustration": "images/animation-collecte2.svg",
        "illustrationpptx": "images/animation-acculturation.svg"
      },
    ]
  },
  {
    "name": "Bilan",
    "picto": "images/ico-head.svg",
    "content": "Suppression de tâches chronophages\n\nLibération de temps pour l’accessibilité"
  },
  {
    "name": "RSE",
    "content": "La responsabilité sociétale des entreprises",
    "slides": [
      {
        "name": "Suivi de qualité globale",
        "content": "Intégrer d’autres référentiels : RGPD, sécurité, Éco-conception, Référentiels mobiles…"
      },
      {
        "legend": "Descriptions des préconisations",
        "screenshot": "images/illustration-qualite-bugs.png"
      },
      {
        "legend": "Liste des préconisations",
        "screenshot": "images/illustration-qualite-synthese.png"
      },
      {
        "name": "Acculturation",
        "illustration": "images/animation-acculturation.svg",
        "illustrationpptx": "images/animation-fin.svg"
      },
      {
        "name": "Groupes de compétence",
        "illustration": "images/people.svg",
        "illustrationpptx": "images/people-pptx.svg",
      }
    ]
  },
  {
    "name": "Merci"
  }
]


if (theme === "devfest") {
  logo = "images/logo-dev-fest.png"
  logodark = "images/logo-dev-fest.png"
  background = "images/fond-devfest.jpg"
  backgroundcolor = "#213131"
  maintitle = 'Accessibilité au cœur des développements'
  content = [
    {
      "name": "¿\xa0Auditeur\xa0Accessibilité\xa0?"
    },
    {
      "name": "Un monde numérisé\xa0?",
      "slides": [{
          "name": "Travail commun",
          "picto": "images/ico-courriel.svg",
          "content": "Informations échangées par mail."
        },
        {
          "name": "3 réunions pour 3 sujets",
          "illustration": "images/animation-http1.gif",
          "content": "Processus long de réunions."
        },
        {
          "name": "1 réunion pour 3 sujets",
          "illustration": "images/animation-http2.gif",
          "content": "Analyse multi-critères."
        }
      ]
    },
    {
      "name": "À Retenir",
      "picto": "images/ico-head.svg",
      "content": "Bureaucratie numérique trop lourde"
    },
    {
      "name": "Taux de conformité\xa0?",
      "slides": [{
          "name": "RGAA\xa04.1",
          "content": "Référentiel Général d'Amélioration de l’Accessibilité"
        },
        {
          "name": "Audit RGAA",
          "illustration": "images/audit-page.png"
        },
        {
          "name": "Résultat d’audit RGAA",
          "illustration": "images/audit-synthese.png"
        },
        {
          "name": "Synthèse d’audit RGAA",
          "illustration": "images/audit-resultats.png"
        }
      ]
    },
    {
      "name": "À Retenir",
      "picto": "images/ico-head.svg",
      "content": "Exploitation des audits compliqué"
    },
    {
      "name": "Obligation Légale\xa0?",
      "slides": [{
          "name": "1.\xa0conforme",
          "content": "100% conforme, au niveau AA dès aujourd’hui (risque juridique).",
          "note": "Le premier chapitre du décret de 2019 qui impose aux sites internet appartenant à certaines catégories d'être accessibles, et ce sans délai, en conformité avec les normes européennes ou internationales. Cette partie répond aux deux premiers paragraphes de l'article 47 et peut donner lieu à sanction juridique"
        },
        {
          "name": "2.\xa0Transparence",
          "content": "Obligations de transparence, avec un délai de 3 à 5 mois pour la mise en conformité (sanction administrative).",
          "note": "Le second chapitre du décret de 2019 qui impose des obligations de transparence en se basant sur le référentiel du RGAA et l'apposition de mentions obligatoires, et qui répond aux paragraphes 3, 4 et 5 de l'article 47 et pouvant donner lieu à la sanction administrative prévue à l'article 8."
        },
        {
          "name": "3.\xa0Planification",
          "content": "Planification de mise en conformité, avec existence permanente\xa0 d’un schéma pluriannuel valide au maximum 3 ans."
        },
        {
          "name": "Organismes\xa0concernés",
          "content": "1. Les personnes morales de droit public ;\n\n2. Les personnes morales de droit privé délégataires d’une mission de service public, ainsi que celles créées pour satisfaire spécifiquement des besoins d’intérêt général ayant un caractère autre qu’industriel ou commercial ;\n\n3. Les personnes morales de droit privé constituées par une ou plusieurs des personnes mentionnées aux 1° et 2° pour satisfaire spécifiquement des besoins d’intérêt général ayant un caractère autre qu’industriel ou commercial ;\n\n4. Les entreprises à compter d’un seuil de chiffre d’affaires de 250 millions d’euros calculé pour chaque personne sur la base de la moyenne du chiffre d’affaires annuel réalisé en France des trois derniers exercices comptables clos antérieurement à l’année considérée."
        },
        {
          "name": "Ex. Prise en compte (A11Y)",
          "content": "1. une adaptation de l’organisation interne de production et de gestion des sites web et applications concernés ;\n\n2. l’accompagnement des agents par des actions de sensibilisation et de formation ;\n\n3. une modification des procédures de marché ;\n\n4. la prise en charge des personnes en situation de handicap lorsqu’elles signalent des difficultés."
        }
      ]
    },
    {
      "name": "À Retenir",
      "picto": "images/ico-head.svg",
      "content": "Contrainte légale forte"
    },
    {
      "name": "Amélioration\xa0de l’Accessibilité\xa0?",
      "slides": [{
          "name": "S’insérer dans le cycle\xa0d’amélioration",
          "picto": "images/ico-cycle.svg"
        },
        {
          "name": "Trouver le bon interlocuteur",
          "picto": "images/ico-share.svg"
        },
        {
          "name": "Valoriser une démarche",
          "picto": "images/ico-best.svg"
        },
        {
          "name": "Suivi = f(maturité)",
          "illustration": "images/iceberg.svg",
          "illustrationpptx": "images/iceberg-pptx.svg"
        }
      ]
    },
    {
      "name": "Bilan",
      "picto": "images/ico-head.svg",
      "content": "Bureaucratie numérique trop lourde\n\nExploitation des audits compliqué\n\nContrainte légale forte\n\nConvaincre des personnes"
    },
    {
      "name": "Ce qui freine\xa0?",
      "slides": [{
          "name": "Archivage",
          "picto": "images/ico-archive.svg",
          "content": "Conserver les données dans le temps."
        },
        {
          "name": "Collecte",
          "picto": "images/ico-box.svg",
          "content": "Communiquer les taux de chaque démarche d’un organisme."
        },
        {
          "name": "Publication",
          "picto": "images/ico-publish.svg",
          "content": "Mise à jour des documents légaux."
        },
        {
          "name": "Expertise technique",
          "picto": "images/ico-diploma.svg",
          "content": "Référent(s) accessibilité(s)."
        },
        {
          "name": "Acculturation équipe",
          "picto": "images/ico-knowledge.svg",
          "content": "Discours adapté à chaque métier."
        },
        {
          "name": "Périmètre",
          "illustration": "images/animation-depart.svg"
        }
      ]
    },
    {
      "name": "À Retenir",
      "picto": "images/ico-head.svg",
      "content": "Organiser le suivi de l’accessibilité"
    },
    {
      "name": "Simplifier la bureaucratie\xa0?",
      "slides": [{
          "name": "Dépôt Git",
          "content": "Pas de base de données : archivage, écriture collaborative…"
        },
        {
          "name": "GSS",
          "content": "Gestionnaire de Site Statique"
        },
        {
          "legend": "Stockage",
          "screenshot": "images/illustration-arbo.png"
        },
        {
          "name": "Archivage",
          "illustration": "images/animation-archivage.svg",
          "illustrationpptx": "images/animation-collecte.svg"
        },
        {
          "name": "Interface web",
          "content": "Partage d’information en ligne. Document unique de discussion avec une adresse fixe."
        },
        {
          "legend": "Liste des démarches",
          "screenshot": "images/illustration-accueil.png"
        },
        {
          "name": "Collecte",
          "illustration": "images/animation-collecte.svg",
          "illustrationpptx": "images/animation-publication.svg"
        },
        {
          "name": "Génération automatisée",
          "content": "Déclaration d’accessibilité, schéma pluriannuel, statistiques dans le temps…"
        },
        {
          "legend": "Détail d’une démarche",
          "screenshot": "images/illustration-projet.png"
        },
        {
          "legend": "Synthèse d’audit",
          "screenshot": "images/illustration-accessibilite-synthese.png"
        },
        {
          "legend": "Résultat d’audit",
          "screenshot": "images/illustration-accessibilite-criteres.png"
        },
        {
          "legend": "Déclaration d’accessibilité",
          "screenshot": "images/illustration-declaration.png"
        },
        {
          "name": "Publication",
          "illustration": "images/animation-publication.svg",
          "illustrationpptx": "images/animation-collecte2.svg"
        },
        {
          "name": "Open Data",
          "content": "Simplifier la collecte grâce une API, générer des rapports, construire des observatoires…"
        },
        {
          "legend": "API",
          "screenshot": "images/illustration-api.png"
        },
        {
          "name": "Collecte API",
          "illustration": "images/animation-collecte2.svg",
          "illustrationpptx": "images/animation-acculturation.svg"
        },
      ]
    },
    {
      "name": "À retenir",
      "picto": "images/ico-head.svg",
      "content": "Numériser le suivi"
    },
    {
      "name": "RSE",
      "content": "La responsabilité sociétale des entreprises",
      "slides": [{
          "name": "Groupes de compétence",
          "illustration": "images/people.svg",
          "illustrationpptx": "images/people-pptx.svg",
        },
        {
          "name": "Suivi de qualité globale",
          "content": "Intégrer d’autres référentiels : OPQUAST, Éco-conception, Référentiels mobiles…"
        },
        {
          "legend": "Liste des préconisations",
          "screenshot": "images/illustration-qualite-synthese.png"
        },
        {
          "legend": "Descriptions des préconisations",
          "screenshot": "images/illustration-qualite-bugs.png"
        },
        {
          "name": "Acculturation",
          "illustration": "images/animation-acculturation.svg",
          "illustrationpptx": "images/animation-fin.svg"
        }
      ]
    },
    {
      "name": "Bilan",
      "picto": "images/ico-head.svg",
      "content": "Réduire la lourdeur administrative\n\nRédiger une liste limitée de correctifs"
    },
    {
      "name": "Libérer la méthode",
      "slides": [{
          "name": "Thème goHugo",
          "picto": "images/frago.png",
          "note": "Anticiper les demandes légales dans les appels d’offres."
        },
        {
          "name": "Format ouvert",
          "content": "Utilisation du format csv identique aux documents d’audits existant."
        },
        {
          "name": "Open Source",
          "content": "Hébergement à la DINUM, URL fixe pour appeler le thème, confiance institutionnelle…"
        },
        {
          "name": "Exemplarité",
          "content": "Simplifier la démarche pour maximiser le temps pour les corrections."
        },
        {
          "name": "Uniformiser",
          "content": "Proposer d’appliquer la méthode au plus grand monde."
        }
      ]
    },
    {
      "name": "Merci",
      "picto": "images/ico-bye.svg",
      "content": "Unir nos efforts"
    }
  ]
}



let backgroundhome = "background-color: " + backgroundcolor + "; color: #fff;background-image:url(" + background + ");background-size:cover;background-position: center center;"

const Slides = ({ name, content, property, animation }) => (
  <div>
    {name
        ? <h2>{ name }</h2>
        : <span/>
    }
    {content
        ? <p className="small">{ content }</p>
        : <span/>
    }
  </div>
);

const mainlogo = {
  path: logo,
  x: "5%",
  y: "5%",
  w: "10%",
  type: 'cover'
}

const mainlogodark = {
  path: logodark,
  x: "5%",
  y: "5%",
  w: "10%",
  type: 'cover'
}

var bigTitle = {
  x: 0,
  y: 0,
  w: "100%",
  h: "100%",
  align: 'center',
  bold: true,
  fontSize: 48,
  color: 'FFFFFF'
}

var bigTitleBlack = {
  x: 0,
  y: 0,
  w: "100%",
  h: "100%",
  align: 'center',
  bold: true,
  fontSize: 48,
  color: '000000'
}

function App() {
  function PowerPoint(e) {
    e.stopPropagation();
    let pptx = new pptxgen();
    pptx.author = 'Bertrand Keller';
    pptx.company = 'Ministère de l’Économie, des Finances et de la Relance';
    pptx.addSection({ title: "Qui" });
    pptx.addSection({ title: "Quoi" });
    pptx.addSection({ title: "Pourquoi" });
    pptx.addSection({ title: "Comment" });


    pptx.defineSlideMaster({
      title: "MAIN",
      background: {
        path: background,
        color: backgroundcolor
      },
      objects: [{
        image: mainlogodark
      }, ],
    });

    pptx.defineSlideMaster({
      title: "CONTENT",
      background: {
        color: "FFFFFF"
      },
      objects: [{
        image: mainlogo
      }, ],
      slideNumber: {
        x: 0.3,
        y: "90%"
      },
    });

    let slide = pptx.addSlide({ masterName: "MAIN", sectionTitle: "Qui" });

		slide.addText(maintitle, {
			x: "5%",
			y: "40%",
			w: "50%",
      h: 1,
      bold: true,
      fontSize: 32,
      fontFace: 'Segoe UI',
			color: 'FFFFFF',
    });

    slide.addText("- Bertrand Keller", {
			x: "5%",
			y: "80%",
			w: "50%",
      h: 1,
      bold: true,
      fontSize: 22,
      fontFace: 'Segoe UI',
			color: 'FFFFFF',
		});

    slide.addText("@bertrandkeller", {
			x: "65%",
			y: "80%",
			w: "50%",
      h: 1,
      bold: true,
      fontSize: 22,
      fontFace: 'Segoe UI',
			color: 'FFFFFF',
    });

    for (const groups of content) {
      let slides = groups.slides
      pptx.addSection({ title: groups.name });
      if (slides) {
        var varslide = pptx.addSlide({ masterName: "MAIN", sectionTitle: groups.name });
        varslide.addText(groups.name, bigTitle);
      }
      else {
        var varslidee = pptx.addSlide({ masterName: "CONTENT", sectionTitle: groups.name });
        varslidee.addText(groups.name, bigTitleBlack);
        if (groups.content)   { varslidee.addText(groups.content, { x: "5%", y: "75%", w: 9.0, fontSize: 18, align: 'center', lineSpacing: 10 }); }
      }
      if (slides) {
        slides.forEach((text) => {
          var varslideinside = pptx.addSlide({ masterName: "CONTENT", sectionTitle: groups.name });
          var fontsize = 18
          var align = 'left'
          if (text.content) {
            if (text.content.length > 200) {
              fontsize = 12
            }
            if (text.content.length < 60) {
              fontsize = 26
              align = 'center'
            }
            if (text.content.length < 40) {
              fontsize = 32
            }
          }
          if (text.name)                                    { varslideinside.addText(text.name, { x: "20%", y: "15%", fontSize: 32, bold: true }); }
          if (text.content && !text.picto)                  { varslideinside.addText(text.content, { x: "5%", y: "55%", w: 9.0, fontSize: fontsize, align: align }); }
          if (text.picto   && !text.content)                { varslideinside.addImage({ x: "45%", y: "45%", w: 1.0, h: 1.0, path: text.picto }); }
          if (text.content && text.picto)                   { varslideinside.addText(text.content, { x: "5%", y: "75%", w: 9.0, fontSize: 22, align: 'center' }); varslideinside.addImage({ x: "45%", y: "45%", w: 1.0, h: 1.0, path: text.picto }); }
          if (text.illustration)                            { varslideinside.addImage({ x: "10%", y: "30%", w: 8.0, h: 3.5, path: text.illustration }); }
          if (text.illustration && text.illustrationpptx)   { varslideinside.addImage({ x: "10%", y: "30%", w: 8.0, h: 3.5, path: text.illustrationpptx }); }
          if (text.screenshot)                              { varslideinside.addImage({ x: "0%", y: "10%", w: 3.5, h: 3.5, path: text.screenshot, sizing: { type: 'contain', w: "100%", h: "80%" } }); }
        });
      }
    }

    // Il y a 2 ans, je présentais une conférence sur l’Éco-conception : 70% des interfaces que nous réalisons ne sont pas utilisées. Accessibilité
    // Un monde numérisé ? Imaginons, vous voulez avoir une idée de votre taux de conformité, alors… blabla… blabla…… (schéma de fonctionnement)
    // Qu’est-ce qu’un taux de conformité (RGAA) petit tour du côté de ce que demande la loi ? Pourquoi c’est important ? Qu'est-ce qui est révélé ? <== Engagement de moyen
    // Comment ça devrait être (schéma) ? Les ponts bloquants…
    // Est-ce qu'on peut simplifier tout ça ? A grane échelle ?

    // Parler du cycle de l’accessibilité : une roue qui tourne ? Un jeu de plateau ? Un jeu par étape.



		pptx.writeFile({ fileName: "bertrand-keller.pptx" });
	}

  //console.log(content.filter(item => !!item.slides).map( item => console.log(item)))

  let array = []

  content.forEach((group) => {
    var absolute = ""
    var property = ""
    var content = ""
    var slidedark = ""
    if (group.slides)               { property = "background-color:" + backgroundcolor + ";color:#fff;background-image:url(" + background + ");background-size:cover;background-position:center center;"; slidedark = "slidedark"  }
    if (group.picto)                { property = "background-color:" + backgroundcolor + ";color:#fff;background-image:url(" + group.picto + ");background-size:8%;background-position:center 20%;"; absolute = "absolute"; slidedark = "slidedark" }
    if (group.content)              { content = group.content }
    array.push({name: group.name, content: content, property: property, absolute: absolute, slidedark: slidedark })
    if (group.slides) {
      group.slides.forEach((groupinside) => {
        var nameslide = ""
        var propertyslide = ""
        var absoluteslide = ""
        var contentslide = ""
        var animationslide = ""
        var slidedarkslide = ""
        if (groupinside.name)        { nameslide = groupinside.name }
        if (groupinside.picto)       { propertyslide  = "background-image:url(" + groupinside.picto + ");background-size:15%;background-position: center center;" ; absoluteslide = "absolute"  }
        if (groupinside.illustration){ propertyslide  = "background-image:url(" + groupinside.illustration + ");background-position: center center;background-size: auto 60%" ; absoluteslide = "absolute" }
        if (groupinside.screenshot)  { propertyslide  = "background-image:url(" + groupinside.screenshot + ");background-position: center center;background-size: auto 90%" ; absoluteslide = "absolute" }
        if (groupinside.animation)   { animationslide = groupinside.animation ; absoluteslide = "absolute" }
        if (groupinside.content)     { contentslide   = groupinside.content }
        array.push({name: nameslide, content: contentslide, animation: animationslide, property: propertyslide, absolute: absoluteslide, slidedark: slidedarkslide })
      })
    }
  })

  console.log(array)

	return (
    <main className="container">
      {logo
        ? <img className="logo" src={ logo } width="100" alt="" />
        : <span/>
      }
      {logodark
        ? <img className="logo dark" src={ logodark } width="100" alt="" />
        : <span/>
      }
      <div data-body-class="slidedark" data-body-style={ backgroundhome }>
        <h2>{ maintitle }</h2>
        <button id="stopPropagation" type="button" className="btn primary small" onClick={(_ev) => PowerPoint(_ev)}>Télécharger la présentation PowerPoint</button>
      </div>
      {array.map((group) => (
          <div data-body-class={group.slidedark} data-absolute={group.absolute} data-body-style={group.property}>
          <Slides
            property={`${group.property}`}
            name={`${group.name}`}
            content={`${group.content}`}
            animation={`${group.animation}`}
          />
          </div>
        ))}
    </main>
	);
}

export default App;
